import React from 'react';
import { BaseStaticLayersGL } from '@rsos/components/capstone/common/Map/useDeckGL/StaticLayersGL/BaseStaticLayersGL';
import CRGGL from './CRGGL';

export const StaticLayersGL = ({ overlay, removedID, isMapIconDisabled }) => {
  return (
    <>
      <BaseStaticLayersGL
        overlay={overlay}
        isMapIconDisabled={isMapIconDisabled}
      />
      <CRGGL
        overlay={overlay}
        removedID={removedID}
        isMapIconDisabled={isMapIconDisabled}
      />
    </>
  );
};

export default StaticLayersGL;
